module.exports = __webpack_public_path__ + "static/rutherford-1-6e4b232825e0da0dfdfe1dd68108cb00.png";